<template>
    <div class="styled-container">
                <v-data-table v-if="loaded" :headers="headers" :search="search" :items="upcomingEvent" class="styled-table" :dark="dark">
                    <template v-if="loaded" v-slot:items="props">
                        <td>{{new Date(props.item.startTime) | date }}</td>
                        <td>{{ props.item.tournamentName }}</td>
                        <td>{{ props.item.eventName }}</td>
                    </template>
                </v-data-table>
    </div>
</template>

<script>
    import upcomingEventsApi from '../api/upcomingEvents'
    import sports from '../components/Sports.vue';
    import { HubConnection } from "@aspnet/signalr";
    import * as CONFIG from "../config"

    export default {
        name: 'UpcomingEvents',
        components: {
            sports
        },
        data() {
            return {
                loaded: false,
                upcomingEvent: null,
                ueIndex: [[true], [false], [true], [false], [true]],
                currentUpcomingSport: [],
                search: '',
                headers: [
                    {
                        text: 'Time',
                        sortable: true,
                        value: 'startTime',
                    },
                    { text: 'Tournament', value: 'tournamentName' },
                    { text: 'Event Name', value: 'eventName' }
                ],
                dark: CONFIG.DARK_MODE
            }
        },
        props: {
            sport: String,
            eventName: String,
            startTime: String,
            connection: HubConnection,
            IsStreaming: Boolean,
            streamingEventsHeading: Boolean,
        },
        watch: {
            sport: function (newSport, oldSport) {
                if (newSport !== oldSport && newSport !== 'All Sports') {
                    for (var i = 0; i < this.currentUpcomingSport.length; i++) {
                        this.connection.invoke("UnSubscribe", this.currentUpcomingSport[i] + "upcomingEvents");
                        this.currentUpcomingSport.pop();
                    }
                    if (this.ueIndex === true) {
                        this.connection.invoke("Subscribe", this.sport + "upcomingEvents");
                    }
                    this.getUpcomingEvents(newSport);
                    if (this.connection) {
                        this.connection.on(this.sport + "ua-rcv", (value) => {
                            if (value !== null) {
                                this.addUpcomingEvent(JSON.parse(value));
                            }
                        });
                        this.connection.on(this.sport + "ur-rcv", (value) => {
                            if (value !== null) {
                                this.removeUpcomingEvent(JSON.parse(value));
                            }
                        });
                    }
                }
            },
            ueIndex: function () { }
        },
        methods: {
            getTime(date) {
                //var hours = date.getHours();
                //var mins = date.getMinutes();
                //if (mins <= 9)
                //    mins = '0' + mins
                //return hours + ':' + mins
                return date

            },
            getUpcomingEvents(sport) {
                if(sport == "Streaming"){
                    upcomingEventsApi.getActiveEventsAll()
                    .then(data => {
                        this.upcomingEvent = data.responseObject;
                        this.loaded = true 
                        this.streamingEventsHeading = true;
                        this.IsStreaming = true;
                    })
                    
                }else{
                    upcomingEventsApi.getUpcomingEvents(sport)
                    .then(data => {
                        this.upcomingEvent = data.responseObject;
                        this.loaded = true;
                        this.IsStreaming = false;
                        this.streamingEventsHeading = false;
                    }) 
                }
            },

            addUpcomingEvent(newEvent) {
                var found = false
                for (let event in this.upcomingEvent) {
                    if (this.upcomingEvent[event].fixtureID == newEvent.FixtureID) {
                        found = true;
                    }
                }
                if (!found) {
                    this.upcomingEvent.push(newEvent);
                }
            },
            removeUpcomingEvent(removeId) {
                for (let eventIndex in this.upcomingEvent) {
                    if (this.upcomingEvent[eventIndex].fixtureID === removeId.fixtureID) {
                        this.upcomingEvent.splice(eventIndex, 1);
                    }
                }

            },
            getUpcomingEventsToggle(ueIndex) {
                if (ueIndex) {
                    this.connection.invoke("Subscribe", this.sport + "upcomingEvents");
                    this.currentUpcomingSport.push(this.sport);
                } else {
                    this.connection.invoke("UnSubscribe", this.sport + "upcomingEvents");
                }
            },

            SetSportCall(sport,status,tournamentName,eventName){
                if(this.IsStreaming){
                    if(status == 1){
                        this.$root.$emit('SportCall',sport);
                        this.$root.$emit('TournamentPanelOpen', tournamentName, sport,eventName);
                        this.streamingEventsHeading = false;
                        this.IsStreaming = false;
                    }
                } 
            }
        },
        filters: {
            '24HourFormat': function (value) {
            if (!value) return '';

            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            };

            const date = new Date(value);
            return date.toLocaleString('en-US', options).replace(',', '');
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .v-datatable__actions__select {
        display: none !important;
    }

    .odd {
        color: gold;
    }

    .bold {
        font-weight: 700;
        padding-right: 10px;
    }

    .table {
        width: 100%;
        color: #696969;
        overflow-wrap: break-word;
    }

    .th {
        color: #696969;
        border-bottom: 2px solid #696969;
    }

    .th, .td {
        text-align: left;
        padding: 4px;
        font-size: 14px !important;
        padding-bottom: 10px !important;
        font-weight: 300;
    }

    .tournament-title.upcoming {
        padding-top: 7px;
        padding-bottom: 7px;
        padding-left: 10px;
        background-color: #8064E6;
        border-color: #8064E6 !important;
    }

    .grey.darken-2 {
        background-color: #8064E6 !important;
    }

    .styled-container {
        border: 1px solid #E6EDFF;
        border-radius: 10px;
        padding: 2px;
        background-color: #fff;
    }

    .styled-table {
        border-radius: 10px;
        background-color: #696969;
    }

    @media (max-width: 960px) {
        th, td {
            text-align: left;
            font: normal normal normal 9px/13px Poppins !important;
            letter-spacing: 0px;
            color: #808191;
        }
    }

    @media only screen and (max-width: 768px), (min-device-width: 768px) and (max-device-width: 1024px) {
        .th, .td {
            text-align: left;
            font-size: 11px !important;
            font-weight: 300;
        }

    }
</style>
